import {InvListElementType, InvListMapType, InvSearchParamType} from "../interface";

export const invSearchParamInit: InvSearchParamType = {
    keyword: "",
    keywordType: "1",
    // 내부수정: 제품군 추가, 재고에서는 안 쓰임
    keyword1: "",
    keywordType1: "1",
    keyword2: "",
    keywordType2: "1",
    limit: 10,
    pageNo: 1,
    statusCodeList: ["1", "2"]
}

export const invListMapInit: InvListMapType = {
    totalCount: 0,
    inventoryList: []
}

export const invListElementInit: InvListElementType = {
    inventoryId: 0,
    vendor: "",
    category: "",
    barcode: "",
    newTxtNmItem: "",
    new_txt_nm_item: "",
    newTxtStndItem: "",
    new_txt_stnd_item: "",
    majorCategory: "",
    subCategory: "",
    inventoryUnit: 0,
    inventoryAmount: 0,
    erpProductImageVO: {},
    currency: "",
    // 내부수정: 제품군 추가
    productRange: ""
}
